<template>
  <div id="app">
    <!--    <Header v-if="$route.name !== 'login'"></Header>-->
    <div class="iv-app-content iv-all-height iv-remove-padding" v-if="newHomePageRoutes.includes($route.name)">
      <router-view/>
    </div>
    <div
        v-else
        class="iv-app-content"
        :class="{'iv-all-height': ($route.name === 'login'),'iv-all-height': isMobile, 'iv-remove-padding': removePaddingBottomRoutes.includes(routeName)}"
    >
      <router-view/>
    </div>
    <!--  TODO 文化大事记以及新闻投稿于2024年5月13日注释掉，此功能为boe功能。电子城不需要显示  -->
<!--    <div class="right-tabs-container" v-if="!isMobile && !newHomePageRoutes.includes($route.name)">-->
<!--      <a class="cultural" href="javascript:;" @click="goToPage">-->
<!--        <img src="@/assets/images/culture.png">-->
<!--        <p>文化大事记</p>-->
<!--      </a>-->
<!--      <a class="contribute" href="javascript:;" @click="goToPage2">-->
<!--        <img src="@/assets/images/contribute.png">-->
<!--        <p>新闻投稿</p>-->
<!--      </a>-->
<!--      <a class="services" :href="ccoServiceUrl" target="_black">-->
<!--        <p>FU仔</p>-->
<!--      </a>-->
<!--      <a class="qrcode" href="javascript:;" @mouseover="showQrcode"  @mouseleave="hideQrcode">-->
<!--        <img src="@/assets/images/erweima.png">-->
<!--        <p>BOE企业文化</p>-->
<!--      </a>-->
<!--      <div class="qrcode-big" v-show="isShow" @mouseover="showQrcode"  @mouseleave="hideQrcode">-->
<!--        <img src="@/assets/images/erweima.png">-->
<!--        <p>文化内驱 凝心聚气</p>-->
<!--        <p>欢迎扫码关注</p>-->
<!--      </div>-->

<!--    </div>-->

  </div>
</template>

<script>
import {mapMutations} from 'vuex'
import Header from '@/views/header'

export default {
  name: 'App',
  data() {
    return {
      routeName: '',
      removePaddingBottomRoutes: [],
      // 机器人链接地址
      ccoServiceUrl: process.env.NODE_ENV !== 'production' ? 'http://chatrobottest.boe.com.cn/chat/CCOService' : 'http://chatrobot.boe.com.cn/chat/CCOService',
      isShow: false,
      isMobile: false,
      newHomePageRoutes: ['newHomeIndex']
    }
  },
  created() {
    if (this.loadPageVar("accessToken")) {
      this.isMobile = true
    }
  },
  methods: {
    ...mapMutations({
      skin: 'SKIN'
    }),
    loadPageVar(sVar) {
      return decodeURI(window.location.href.replace(new RegExp("^(?:.*[&\\?]" + encodeURI(sVar).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
    },
    showQrcode() {
      this.isShow = true;
    },
    hideQrcode() {
      this.isShow = false;
    },
    //移除padding-bottom
    setStyle() {
      this.routeName = this.$route.name
      this.removePaddingBottomRoutes = ['activityList']
    },
    goToPage() {//文化大事记
      const {href} = this.$router.resolve({
        name: 'culturalMemorabilia',
      })
      window.open(href, '_blank')
    },
    goToPage2() {//投稿
      let href = process.env.VUE_APP_URL + '/userDeliver/contribute?access_token=' + localStorage.getItem('token')
      window.open(href, '_blank')
    },
  },
  watch: {
    '$route'(to, from) {
      if (to.name != 'welcome') {
        let brame = document.querySelector('.iv-breadcrumb-wrapper')
        if (brame) {
          brame.style.display = 'block'
        }
      } else {
        let brame = document.querySelector('.iv-breadcrumb-wrapper')
        if (brame) {
          brame.style.display = 'none'
        }
      }
      this.setStyle()
    }
  },
  components: {
    Header
  }
}
</script>

<style lang="scss">
/*全局样式注入*/
@import '@/assets/css/base/index.scss';

body, html, #app {
  #app {
    font-family: 'Microsoft YaHei', 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: #F5F7FA;
    height: 100vh;
    overflow: hidden;
  }
}

body {
  overflow-x: hidden !important;
  scrollbar-width: thin;
}

.iv-app-content {
  overflow-y: auto;
  // margin-top: 64px;
  height: 100vh;
  padding-bottom: 30px;
  // background-color: #fff;
}

.iv-remove-padding {
  padding-bottom: 0;
}

.iv-all-height {
  height: 100vh;
  margin-top: 0;
}

::-webkit-scrollbar {
  width: 9px;
  height: 9px;
}

::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background: #c2c2c2;
}

::-webkit-scrollbar-track {
  border-radius: 6px;
  background: rgba(250, 250, 250, .9);
}

//去掉遮罩层
.ivu-spin-fullscreen {
  display: none;
}
</style>
<style lang="scss" scoped>
.right-tabs-container {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  right: 40px;
  z-index: 10;

  a {
    display: block;
    margin-bottom: 30px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  // 文化大事记
  .cultural {
    width: 48px;
    height: 48px;
    position: relative;

    img {
      width: 34px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      //height: 100%;
    }

    p {
      position: absolute;
      bottom: -15px;
      white-space: nowrap;
      left: -5px;
    }
  }

  //投稿
  .contribute {
    width: 48px;
    height: 48px;
    position: relative;

    img {
      width: 27px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      //height: 100%;
    }

    p {
      position: absolute;
      bottom: -15px;
      white-space: nowrap;
    }
  }

  //二维码
  .qrcode {
    width: 48px;
    height: 48px;
    position: relative;

    img {
      width: 48px;
      height: 48px;
    }

    p {
      position: absolute;
      bottom: -15px;
      white-space: nowrap;
      left: -10px;
    }
  }

  .qrcode-big {
    //width: 150px;
    //height: 150px;
    position: absolute;
    right: 70px;
    bottom: -60px;
    background: #fff;
    //padding: 10px;
    padding: 8px 16px;
    box-sizing: border-box;
    box-shadow: 0 2px 12px rgba(0, 0, 0, .15);

    img {
      width: 150px;
      height: 150px;
    }

    p {
      text-align: center;
      color: rgba(0, 0, 0, 0.85);
      fonrt-size: 16px;
    }

    &:after {
      content: '';
      position: absolute;
      top: 50%;
      right: -5px;
      transform: translateY(-50%);
      z-index: 1;
      width: 0;
      height: 0;
      border-left: 5px solid #fff;
      border-top: 5px solid transparent;
      border-bottom: 5px solid transparent;
    }
  }

  // 机器人
  .services {
    width: 48px;
    height: 48px;
    background: url("~@/assets/images/zhayan.gif");
    background-size: 48px;
    position: relative;

    &:hover {
      background: url("~@/assets/images/erweima.gif");
      background-size: 48px;
    }

    img {
      width: 100%;
      height: 100%;
    }

    p {
      position: absolute;
      bottom: -20px;
      white-space: nowrap;
      left: 50%;
      transform: translateX(-50%);
    }
  }


}
</style>
